module.exports = __webpack_public_path__ + "img/P90x3.302c9c6d.png";